// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[class^=NsExpireDateForm_] .date-field{max-width:220px;margin-right:8px}", ""]);
// Exports
module.exports = exports;
